export default __webpack_public_path__ + "static/media/IRANSansWeb(FaNum)_Bold.62df0689.woff2";